import React from "react";
import ProjectDetails from "../../Components/ProjectDetails/project-details";

function ProjectDetailsPage() {
  return (
    <ProjectDetails />
  )
}

export default ProjectDetailsPage ;